// import the library
import { library } from '@fortawesome/fontawesome-svg-core'

// import your icons
import {
  faArrowDown,
  faArrowUp,
  faArrowTrendUp,
  faAt,
  faBackward,
  faBackwardFast,
  faBars,
  faBasketShopping,
  faBookOpenReader,
  faBullhorn,
  faCalendarDays,
  faChartGantt,
  faCheck,
  faDollarSign,
  faEdit,
  faExclamationCircle,
  faEllipsisVertical,
  faForward,
  faForwardFast,
  faFileContract,
  faFileCsv,
  faGear,
  faInfoCircle,
  faKey,
  faLock,
  faMoneyCheckDollar,
  faNewspaper,
  faPencil,
  faPenToSquare,
  faPeopleArrows,
  faPersonDigging,
  faPlus,
  faRobot,
  faRotate,
  faTrashCan,
  faTruckFast,
  faUser,
  faUserCircle,
  faUserGraduate,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faArrowDown,
  faArrowUp,
  faArrowTrendUp,
  faAt,
  faBackward,
  faBackwardFast,
  faBars,
  faBasketShopping,
  faBookOpenReader,
  faBullhorn,
  faCalendarDays,
  faChartGantt,
  faCheck,
  faDollarSign,
  faEdit,
  faExclamationCircle,
  faEllipsisVertical,
  faFileContract,
  faFileCsv,
  faForward,
  faForwardFast,
  faGear,
  faKey,
  faInfoCircle,
  faLock,
  faMoneyCheckDollar,
  faNewspaper,
  faPencil,
  faPenToSquare,
  faPeopleArrows,
  faPersonDigging,
  faPlus,
  faRobot,
  faRotate,
  faTrashCan,
  faTruckFast,
  faUser,
  faUserCircle,
  faUserGraduate,
  faXmark
)
